// Модалка «Связаться с разрабом» — открывается из FAB.
//
// Состояния:
//   "menu"     — FAQ-список + кнопка «Написать обращение» + ссылка «Мои обращения»
//   "create"   — форма создания тикета (TicketCreateForm)
//   "article"  — открыта конкретная статья FAQ
//   "done"     — тикет создан, кнопка перехода к /support/my (Этап 4)
//
// Бэкенд: /api-storys/kubikon3d/tickets/*
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { ChatBubbleLeftRightIcon } from "../icons/ChatBubbleLeftRightIcon";
import { BookOpenIcon } from "../icons/BookOpenIcon";
import FaqList from "./FaqList";
import FaqArticle from "./FaqArticle";
import TicketCreateForm from "./TicketCreateForm";

export default function SupportModal({ onClose }) {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const [mode, setMode] = useState("menu");          // menu | create | article | done
  const [articleId, setArticleId] = useState(null);
  const [createdId, setCreatedId] = useState(null);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const openArticle = (a) => {
    setArticleId(a.id);
    setMode("article");
  };

  const goCreate = () => {
    setMode("create");
  };

  const onCreated = (id) => {
    setCreatedId(id);
    setMode("done");
  };

  return (
    <div className="sup-overlay" onClick={handleOverlayClick}>
      <div className="sup-modal" role="dialog" aria-label="Связаться с разрабом">
        <div className="sup-modal__head">
          <ChatBubbleLeftRightIcon size={20} color="#3357ff" />
          <div className="sup-modal__title">
            {mode === "menu"    && "Связаться с разрабом"}
            {mode === "create"  && "Новое обращение"}
            {mode === "article" && "Из FAQ"}
            {mode === "done"    && "Обращение отправлено"}
          </div>
          <button
            className="sup-modal__close"
            onClick={onClose}
            aria-label="Закрыть"
          >×</button>
        </div>

        {/* Кнопки действий — СВЕРХУ, всегда видны над прокручиваемым FAQ.
            Только в режиме "menu", в create/article/done свои контролы. */}
        {mode === "menu" && (
          <div className="sup-modal__actions">
            <button type="button" className="sup-btn-primary"
                    onClick={goCreate}>
              <ChatBubbleLeftRightIcon size={16} color="#fff" />
              Написать обращение
            </button>
            {isAuthenticated && (
              <button type="button" className="sup-btn-ghost"
                      onClick={() => { onClose(); navigate("/support/my"); }}>
                Мои обращения
              </button>
            )}
            <button type="button" className="sup-btn-ghost"
                    onClick={() => { onClose(); navigate("/support"); }}>
              Открыть полный FAQ
            </button>
          </div>
        )}

        <div className="sup-modal__body">
          {mode === "menu" && (
            <>
              <div className="sup-msg-info" style={{ marginBottom: 14,
                                                     display: "flex",
                                                     gap: 8,
                                                     alignItems: "center" }}>
                <BookOpenIcon size={18} color="#475569" />
                <span>
                  Загляни в FAQ — там ответы на частые вопросы.
                  Если ответа нет, напиши прямо МИНу — отвечаем в течение 48 часов.
                </span>
              </div>

              <FaqList onPickArticle={openArticle} maxPerCategory={3} />
            </>
          )}

          {mode === "create" && (
            <>
              <button type="button" className="sup-btn-ghost"
                      onClick={() => setMode("menu")}
                      style={{ marginBottom: 12 }}>
                ‹ Назад к FAQ
              </button>
              <TicketCreateForm
                onCreated={onCreated}
                onPickFaqArticle={openArticle}
              />
            </>
          )}

          {mode === "article" && (
            <FaqArticle
              id={articleId}
              onBack={() => setMode("menu")}
              onCreateTicket={goCreate}
            />
          )}

          {mode === "done" && (
            <div>
              <div className="sup-msg-ok" style={{ marginBottom: 14 }}>
                Обращение №{createdId} отправлено. МИН увидит и ответит в
                течение 48 часов.
              </div>
              {isAuthenticated ? (
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <button type="button" className="sup-btn-primary"
                          onClick={() => {
                            onClose();
                            navigate(`/support/ticket/${createdId}`);
                          }}>
                    Открыть переписку
                  </button>
                  <button type="button" className="sup-btn-ghost"
                          onClick={onClose}>
                    Закрыть
                  </button>
                </div>
              ) : (
                <div className="sup-msg-info">
                  Ответ придёт на указанный email. Если хочешь видеть переписку
                  на сайте — войди в аккаунт.
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
